<template>
<div class="bg-gray-100 font-sans">
<div class="container mx-auto px-4 py-10">
  <div class="relative wrap overflow-hidden h-full">
    <div class="flex overflow-x-auto py-8">
      <div class="absolute top-8 left-0 h-1 w-full bg-gray-300"></div>
      <div
          v-for="(event, index) in timelineEvents"
          :key="index"
          class="flex-shrink-0 px-6"
          style="min-width: 300px;"
      >
        <div class="relative">
          <div
              class="absolute top-8 left-1/2 w-4 h-4 rounded-full -translate-x-1/2 -translate-y-1/2 border-4 border-gray-100"
              :style="{ backgroundColor: event.color }"
          ></div>

          <!-- Event content card -->
          <div class="mt-14 w-full">
            <div class="bg-white p-4 rounded-lg shadow-md border-t-4" :style="{ borderTopColor: event.color }">
              <time class="text-sm font-semibold text-gray-500">{{ event.date }}</time>
              <h3 class="text-lg font-bold text-gray-800 mt-1">{{ event.title }}</h3>
              <p class="text-base text-gray-600 mt-2">{{ event.description }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
  name: 'HorizontalBasic',
  props: {
    timelineEvents: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
/* Add a scrollbar style for better UX on desktop */
.overflow-x-auto::-webkit-scrollbar {
  height: 8px;
}

.overflow-x-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.overflow-x-auto::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
